export default __webpack_public_path__ + "static/media/GR00051-color_spot_gradient_2.b6a59fd6.svg";